import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { appointmentForecastFacts } from "../subjects/stopEvent/appointmentForecastFacts";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * Storyboard's forecast recrossed a stop's appointment: a stop forecast late is projected to arrive in time again.
 *
 * Minted by the appointment-risk sweep rather than by a vendor, on a stop's recovery from late, and only to pair with
 * a `forecastLate` it wrote.
 */
export const forecastOnTimeV1 = tmsEventKind(
  { category: "appointment", kind: "forecastOnTime", version: 1 },
  { refs: stopEventRefs, facts: appointmentForecastFacts },
);

export const ForecastOnTimeV1Schema = forecastOnTimeV1.schema;
export const ForecastOnTimeV1FactsSchema = forecastOnTimeV1.facts;

export type ForecastOnTimeV1 = z.infer<typeof ForecastOnTimeV1Schema>;
export type ForecastOnTimeV1Facts = z.infer<typeof ForecastOnTimeV1FactsSchema>;

/** Every version of `forecastOnTime`, keyed by version. What `catalog.ts` places under `appointment`. */
export const forecastOnTime = { 1: forecastOnTimeV1 } as const;
